<template>
  <section>
    <Feature title="Data" :iconClass="'fa-pencil-square-o'">
      <FormRow :fieldNameArr="['Form No']">
        <Input v-model="formNo" slot="a" disabled />
      </FormRow>
      <Table :columns="quotationColumnList" :data="quotationList" row-key="key">
        <template slot-scope="{ row, index }" slot="historyComments">
          <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showHistoryCommentsModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="infoRecord">
          <div v-if="row.infoRecordFlag">
            <span>YES</span>
            <Icon type="ios-create" size="28" class="text-delta-blue" @click="showInfoRecordMaintainModal(index, row.uuid)" />
          </div>
          <div v-else>
            <span>NO</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="singleCross">
          <span v-if="row.quotationHighPrice.orgCheck === 'C'">Cross</span>
          <span v-if="row.quotationHighPrice.orgCheck === 'S'">Single</span>
        </template>
        <template slot-scope="{ row, index }" slot="highPriceReasonCategory">
          <div v-if="row.highPriceReasonCategory">
            <span>{{ row.highPriceReasonCategory.highPriceReasonCategory }}</span>
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="diff">
          <span v-if="row.quotationHighPrice.priceDifference">{{ row.quotationHighPrice.priceDifference }}%</span>
        </template>
        <template slot-scope="{ row, index }" slot="log">
          <Icon type="ios-paper" size="28" class="text-delta-blue" @click="showLogModal(index, row.uuid)" />
        </template>
        <template slot-scope="{ row, index }" slot="quotationFiles">
          <Icon :type="row.supplierAttachments && row.supplierAttachments.filter(attachement => !attachement.deleted).length > 0 ? 'ios-cloud-download' : ''" size="28" class="text-delta-blue" @click="showQuotationFilesModal(index)" />
        </template>
        <template slot-scope="{ row, index }" slot="referenceFile">
          <Icon :type="row.cpcToSupervisorAttachments && row.cpcToSupervisorAttachments.filter(attachement => !attachement.deleted).length > 0 ? 'ios-cloud-download' : ''" size="28" class="text-delta-blue" @click="showReferenceFileModal(index)" />
        </template>
      </Table>
    </Feature>
    <ButtonRow>
      <Button type="info" @click="back" slot="1">{{ $t("BACK") }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="historyCommentsModal"
      :title="$t('HISTORY') + ' ' + $t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="historyComments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="infoRecordMaintainModal" :title="$t('INFO_RECORD_MAINTAIN')">
      <InfoRecordMaintain v-if="infoRecordMaintainModal" :quotation="quotation" :materialTypeList="materialTypeList"></InfoRecordMaintain>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logModal" :title="$t('PROCESS_LOG')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <TablePage :columnsList="quotationLogColumnList" :resultList="quotationLogList" :tableMaxHeight="550"></TablePage>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="flowCommentModal" :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="supplierQuotationFilesModal" :title="$t('QUOTATION_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="supplierAttachments"></FileDocument>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="referenceFileModal" :title="$t('REFERENCE_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="cpcToSupervisorAttachments"></FileDocument>
      </div>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import { FloraEditorConfig } from "@/util/common"
import FileDocument from '../../components/FileDocument.vue'
import InfoRecordMaintain from "@/views/quotation/InfoRecordMaintain"

export default {
  name: "StatusReportHighPriceDetail",
  props: {
    formNo: {
      type: String,
      default: ""
    }
  },
  components: {
    InfoRecordMaintain,
    FileDocument
  },
  created() {
    const vueInstance = this;
    vueInstance.toggleLoading(true);
    vueInstance.$quotationHttp
      .get("status-report/detail?formNo=" + vueInstance.formNo)
      .then(response => {
        vueInstance.quotationList.push(response.data);
      })
      .catch(error => {
        AlertInfo(vueInstance, vueInstance.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
          .then(() => {
            console.error(error);
            vueInstance.Back();
          });
      })
      .finally(() => {
        vueInstance.toggleLoading(false);
      });
    vueInstance.$quotationHttp
      .get("/quotation/material-type")
      .then(response => {
        if (response.data) {
          vueInstance.materialTypeList = response.data;
        }
      });
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      quotation: {},
      quotationList: [],
      quotationUuid: "",
      materialTypeList: [],
      quotationLogList: [],
      supplierAttachments: [],
      cpcToSupervisorAttachments: [],
      cpcToVendorAttachments: [],
      historyComments: "",
      historyCommentsModal: false,
      infoRecordMaintainModal: false,
      logModal: false,
      flowComment: "",
      flowCommentModal: false,
      supplierQuotationFilesModal: false,
      referenceFileModal: false
    };
  },
  methods: {
    ...mapGetters(["getModalSize"]),
    ...mapActions(["toggleLoading"]),
    showHistoryCommentsModal(index, uuid) {
      this.toggleLoading(true);
      this.$queryQuotationLog(this, uuid)
        .then(data => {
          this.quotationUuid = uuid;
          this.historyComments = "";
          data.forEach(log => {
            if (log.quotationRole) {
              this.historyComments = this.historyComments + this.$t("ROLE") + ": " + log.quotationRole + ", ";
            }
            if (log.quotationRole) {
              this.historyComments = this.historyComments + this.$t("STATUS") + ": " + log.flowStatus + ", ";
            }
            if (log.groupAccount) {
              this.historyComments = this.historyComments + this.$t("GROUP_ACCOUNT") + ": " + log.groupAccount.code + "/" + log.groupAccount.companyName + ", ";
            }
            if (log.created) {
              this.historyComments = this.historyComments + this.$t("CREATE_DATE") + ": " + log.created + ": <br>";
            }
            if (log.flowComment) {
              this.historyComments = this.historyComments + log.flowComment;
            }
            this.historyComments = this.historyComments + "<hr style=\"border:1px dashed #000; height:1px\">";
          });
          this.historyCommentsModal = true;
        })
        .catch(error => {
          AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
            .then(() => {
              console.error(error);
            });
        })
        .finally(() => {
          this.toggleLoading(false);
        });
    },
    showInfoRecordMaintainModal(index, uuid) {
      this.quotation = this.quotationList[index];
      this.infoRecordMaintainModal = true;
    },
    showLogModal(index, uuid) {
      this.quotationLogList = this.quotationList[index].logs;
      this.quotationUuid = uuid;
      this.logModal = true;
    },
    showQuotationFilesModal(index) {
      this.supplierAttachments = this.quotationList[index].supplierAttachments.filter(attachment => !attachment.deleted);
      this.supplierQuotationFilesModal = true;
    },
    showReferenceFileModal(index) {
      this.cpcToSupervisorAttachments = this.quotationList[index].cpcToSupervisorAttachments.filter(attachment => !attachment.deleted);
      this.referenceFileModal = true;
    },
    back() {
      this.$router.push({
        name: "STATUS_REPORT"
      });
    }
  },
  computed: {
    modalSize() {
      return this.getModalSize();
    },
    quotationColumnList() {
      return [{
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("HISTORY"), 
            h("br"), 
            this.$t("COMMENTS")
          ]);
        },
        align: "center",
        width: 70,
        slot: "historyComments"
      }, {
        title: this.$t("INFO_RECORD"),
        align: "center",
        width: 60,
        slot: "infoRecord"
      }, {
        title: "Single/Cross",
        align: "center",
        width: 150,
        slot: "singleCross"
      }, {
        title: this.$t("HIGH_PRICE_REASON_CATEGORY"),
        align: "center",
        width: 60,
        slot: "highPriceReasonCategory"
      }, {
        title: this.$t("DIFF"),
        align: "center",
        width: 150,
        slot: "diff"
      }, {
        title: this.$t("BG"),
        align: "center",
        width: 60,
        key: "bg"
      }, {
        title: this.$t("BU"),
        align: "center",
        width: 60,
        key: "bu"
      }, {
        title: this.$t("PLANT"),
        align: "center",
        width: 150,
        key: "plant"
      }, {
        title: this.$t("DELTA_PN"),
        align: "center",
        width: 100,
        key: "deltaPart"
      }, {
        title: this.$t("PN_DESCRIPTION"),
        align: "center",
        width: 100,
        key: "deltaPartDesc"
      }, {
        title: this.$t("VENDOR_PN"),
        align: "center",
        width: 80,
        key: "vendorPartNo"
      }, {
        title: this.$t("VENDOR_CODE"),
        align: "center",
        width: 90,
        key: "vendorCode"
      }, {
        title: this.$t("OA_VENDOR_NAME"),
        align: "center",
        width: 90,
        key: "vendorName"
      }, {
        title: this.$t("AGENT"),
        align: "center",
        width: 150,
        key: "agent"
      }, {
        title: this.$t("AGENT_NAME"),
        align: "center",
        width: 150,
        key: "agentName"
      }, {
        title: this.$t("LOG"),
        align: "center",
        width: 60,
        slot: "log"
      }, {
        title: this.$t("ITEM_CATEGORY"),
        align: "center",
        width: 100,
        key: "itemCategory"
      }, {
        title: this.$t("UNIT_PRICE"),
        align: "center",
        width: 90,
        key: "price"
      }, {
        title: this.$t("CURRENCY"),
        align: "center",
        width: 90,
        key: "currency"
      }, {
        title: this.$t("VALID_FROM"),
        align: "center",
        width: 140,
        key: "validFrom"
      }, {
        title: this.$t("VALID_TO"),
        align: "center",
        width: 140,
        key: "validTo"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("QUOTATION"), 
            h("br"), 
            this.$t("FILES")
          ]);
        },
        align: "center",
        width: 60,
        slot: "quotationFiles"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("REFERENCE"), 
            h("br"), 
            this.$t("FILE")
          ]);
        },
        align: "center",
        width: 60,
        slot: "referenceFile"
      }, {
        title: this.$t("APPLY_DATE"),
        align: "center",
        width: 150,
        key: "rfqDate"
      }];
    },
    quotationLogColumnList() {
      return [{
        title: this.$t("ROLE"),
        align: "center",
        width: 150,
        key: "quotationRole"
      }, {
        title: this.$t("STATUS"),
        align: "center",
        width: 150,
        key: "flowStatus"
      }, {
        title: this.$t("GROUP_ACCOUNT"),
        align: "center",
        width: 180,
        render: (h, params) => {
          return h("span", {}, params.row["groupAccount"].code + '/' + params.row["groupAccount"].companyName);
        }
      }, {
        title: this.$t("ACTION"),
        align: "center",
        width: 150,
        key: "flowAction"
      }, {
        title: this.$t("COMMENTS"),
        align: "center",
        width: 150,
        render: (h, params) => {
          if (params.row.flowComment) {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.flowComment = params.row.flowComment;
                  this.flowCommentModal = true;
                }
              }
            });
          }
          return h("span", {}, "");
        }
      }, {
        title: this.$t("CREATE_DATE"),
        align: "center",
        width: 180,
        key: "created"
      }, {
        title: this.$t("PERSON_ACCOUNT"),
        align: "center",
        width: 200,
        key: "personEmail"
      }];
    }
  }
}
</script>